import React from 'react'
import {connect} from 'react-redux'
import {compose} from 'redux'
import {withRouter} from 'react-router-dom'
import {isLoaded, isEmpty} from 'react-redux-firebase'

import {
  isEmailLinkUrl,
  completeEmailLinkSignIn,
  getStoredEmail,
  mapAuthError,
} from '../firebase/authHelpers'
import styles from './FinishSignIn.module.css'

const STATE = {
  VERIFYING: 'verifying',
  NEEDS_EMAIL: 'needs_email',
  SIGNING_IN: 'signing_in',
  ERROR: 'error',
  INVALID_LINK: 'invalid_link',
}

class FinishSignIn extends React.Component {
  state = {
    status: STATE.VERIFYING,
    manualEmail: '',
    errorMessage: '',
  }

  componentDidMount() {
    const url = window.location.href

    if (!isEmailLinkUrl(url)) {
      this.setState({status: STATE.INVALID_LINK})
      return
    }

    const storedEmail = getStoredEmail()
    if (storedEmail) {
      this.finishSignIn(storedEmail, url)
    } else {
      this.setState({status: STATE.NEEDS_EMAIL})
    }
  }

  componentDidUpdate() {
    // Navigate only after rrf has confirmed the auth state in Redux,
    // avoiding a race between the modular sign-in and the Redux update.
    // _navigating guards against the infinite loop caused by history.replace
    // triggering withRouter re-renders which re-enter componentDidUpdate.
    if (
      !this._navigating &&
      this.state.status === STATE.SIGNING_IN &&
      isLoaded(this.props.auth) &&
      !isEmpty(this.props.auth)
    ) {
      this._navigating = true
      this.props.history.replace('/birdex')
    }
  }

  finishSignIn = async (email, url) => {
    this.setState({status: STATE.SIGNING_IN})
    try {
      await completeEmailLinkSignIn(email, url || window.location.href)
      // Navigation is handled in componentDidUpdate once Redux auth state
      // reflects the new user - avoids a LoadingSplash flash.
    } catch (err) {
      this.setState({
        status: STATE.ERROR,
        errorMessage: mapAuthError(err.code),
      })
    }
  }

  onManualEmailChange = (e) => {
    this.setState({manualEmail: e.target.value})
  }

  onManualEmailSubmit = (e) => {
    e.preventDefault()
    const {manualEmail} = this.state
    if (manualEmail) {
      this.finishSignIn(manualEmail, window.location.href)
    }
  }

  render() {
    const {status, manualEmail, errorMessage} = this.state

    if (status === STATE.VERIFYING || status === STATE.SIGNING_IN) {
      return (
        <div className={styles.container}>
          <div className={styles.logo}>
            <img src="/img/icons/logo.svg" alt="Birder logo" />
          </div>
          <h1>Birder</h1>
          <p>Kirjaudutaan sisään...</p>
          <i className="fas fa-spinner fa-pulse" style={{fontSize: '24px'}} />
        </div>
      )
    }

    if (status === STATE.INVALID_LINK) {
      return (
        <div className={styles.container}>
          <div className={styles.logo}>
            <img src="/img/icons/logo.svg" alt="Birder logo" />
          </div>
          <h1>Birder</h1>
          <p className={styles.error}>
            Virheellinen kirjautumislinkki. Linkki on jo käytetty tai se on
            virheellinen.
          </p>
          <a href="/" className={styles.backLink}>
            Takaisin kirjautumiseen
          </a>
        </div>
      )
    }

    if (status === STATE.NEEDS_EMAIL) {
      return (
        <div className={styles.container}>
          <div className={styles.logo}>
            <img src="/img/icons/logo.svg" alt="Birder logo" />
          </div>
          <h1>Birder</h1>
          <p>
            Vahvista sähköpostiosoitteesi kirjautuaksesi sisään tällä laitteella.
          </p>
          <form onSubmit={this.onManualEmailSubmit} className={styles.form}>
            <input
              type="email"
              className={styles.input}
              placeholder="Sähköpostiosoite"
              value={manualEmail}
              onChange={this.onManualEmailChange}
              required
              autoFocus
            />
            <button
              type="submit"
              className={styles.button}
              disabled={!manualEmail}
            >
              Kirjaudu sisään
            </button>
          </form>
        </div>
      )
    }

    if (status === STATE.ERROR) {
      return (
        <div className={styles.container}>
          <div className={styles.logo}>
            <img src="/img/icons/logo.svg" alt="Birder logo" />
          </div>
          <h1>Birder</h1>
          <p className={styles.error}>{errorMessage}</p>
          <a href="/" className={styles.backLink}>
            Yritä uudelleen
          </a>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = (state) => ({
  auth: state.firebase.auth,
})

export default compose(connect(mapStateToProps), withRouter)(FinishSignIn)
